import React, { Fragment } from 'react';
import styled, { keyframes } from 'styled-components';
import '../../../log2base2.css';

export const SiteBtn = styled.button`
  font-size: 15px;
  padding: 8px 16px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  outline: none;
  min-width: 90px;
  color: ${(props) => (props.darkTheme ? 'var(--light)' : 'var(--white)')};
  background: ${(props) => (props.darkTheme ? 'var(--regionalsDark)' : 'var(--regionalsColor)')};
  :hover {
    filter: brightness(94%);
    outline: none;
  }
  :active {
    filter: initial;
  }
  :disabled {
    cursor: not-allowed;
  }
`;

export const FormBtn = styled(SiteBtn)`
  width: 100%;
  padding: 10px 18px;
  min-width: 200px;
  color: ${(props) => (props.darkTheme ? 'var(--light)' : 'var(--white)')};
  background: ${(props) => (props.darkTheme ? 'var(--regionalsDark)' : 'var(--regionalsColor)')};
`;

/* button shine effect */
const LeftOfferShine = keyframes`
0%{
  opacity: 0.6;
  transform: translateX(-100px) skewX(-15deg);
}
100% {    
  transform: translateX(300px)  skewX(-15deg);  
  opacity: 0.6;
}
`;
const RightOfferShine = keyframes`
0%{
  opacity: 0.1;
  transform: translateX(-100px) skewX(-15deg);
}
100% {  
  transform: translateX(300px) skewX(-15deg);  
  opacity: 1;
}
`;

export const BannerBtn = styled(SiteBtn)`
  width: 100%;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--regionalsColor);
  @media (min-width: 320px) {
    width: 220px;
  }
  @media (min-width: 481px) {
    margin: 0px auto;
  }
  @media (min-width: 992px) {
    width: 240px;
    padding: 15px 20px;
    margin: 0px auto 0px 0px;
  }
`;

export const SignupInfoBtn = styled(SiteBtn)`
  width: 210px;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--regionalsColor);
  @media (min-width: 320px) {
    width: 220px;
  }
`;

export const CtaBoxBtn = styled(SignupInfoBtn)`
  width: 210px;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--regionalsColor);
  color: var(--white);
  @media (min-width: 320px) {
    width: 220px;
  }
`;

export const SecondaryBtn = styled(SiteBtn)`
  padding: 7px 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.darkTheme ? 'var(--regionalsDark)' : 'var(--regionalsColor)')};
  background: transparent;
  border: 2px solid ${(props) => (props.darkTheme ? 'var(--regionalsDark)' : 'var(--regionalsColor)')};
  &:hover,
  &:active {
    filter: initial;
    outline: none;
    background: #82368017;
  }
`;

export const GhostBtn = styled(SiteBtn)`
  min-width: 90px;
  padding: 4px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.darkTheme ? 'var(--regionalsDark)' : 'var(--regionalsColor)')};
  background: transparent;
  &:hover,
  &:active {
    filter: initial;
    background: ${(props) => (props.darkTheme ? 'var(--blueShadowColor)' : 'var(--siteBorderColor)')};
  }
`;

export const PricingBarBtn = styled(SiteBtn)`
  position: relative;
  overflow: hidden;
  padding: ${(props) => (props.isIndividualPricing ? '8px 4px' : '12px 4px')};
  font-size: 14px;
  font-weight: 600;
  width: 100%;
  color: var(--btnDarkTxt);
  background: #fff;
  @media (min-width: 360px) {
    padding: 12px 4px;
  }
  @media (min-width: 992px) {
    font-size: 15px;
  }
  &:before {
    content: '';
    display: block;
    position: absolute;
    background: rgba(255, 255, 255, 0.6);
    width: 60px;
    height: 100%;
    left: 0;
    top: 0;
    filter: blur(15px);
    animation: ${LeftOfferShine} 4.8s ease-in-out infinite;
  }
  &:after {
    content: '';
    display: block;
    position: absolute;
    background: rgba(255, 255, 255, 0.4);
    width: 30px;
    height: 100%;
    left: 30px;
    top: 0;
    filter: blur(5px);
    animation: ${RightOfferShine} 4.8s ease-in-out infinite;
  }
`;

export const RoundedBtn = styled(SiteBtn)`
  width: 100%;
  height: 100%;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, var(--gradientPrimaryColor), var(--gradientSecondaryColor));
  border-radius: 25px;
`;

export const SpinnerBtn = styled(SiteBtn)`
  width: 100%;
  height: 45px;
  padding: 4px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RegionalsBannerBtn = styled.a`
  padding: 10px 20px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  outline: none;
  text-decoration: none !important;
  text-align: center;
  color: var(--white) !important;
  min-width: 120px;
  background: var(--brandColor);
  :hover {
    border: none;
    outline: none;
    text-decoration: none !important;
    filter: brightness(94%);
  }
  :active {
    filter: initial;
  }
`;

export const DarkSiteBtn = styled(SiteBtn)`
  color: ${(props) => (props.darkTheme ? 'var(--regionalsDark)' : 'var(--white)')};
  background: ${(props) => (props.darkTheme ? 'var(--regionalsDarkBtn)' : 'var(--regionalsColor)')};
`;

export default function RegionalsButton({
  formBtn,
  bannerBtn,
  signUpInfoBtn,
  secondaryBtn,
  ghostBtn,
  pricingBarBtn,
  roundedBtn,
  spinnerBtn,
  regionalsLinkBtn,
  ctaBoxBtn,
  darkBtn,
  isIndividualPricing,
  onClick,
  style,
  children,
  active,
  disabled,
  loadingText,
  id,
  ref,
  href,
  darkTheme,
  from,
}) {
  return (
    <Fragment>
      {bannerBtn ? (
        <BannerBtn id={id} onClick={onClick} style={style} from={from}>
          <span>{children}</span> <span className="fs-18 weight-600">&#10230;</span>
        </BannerBtn>
      ) : signUpInfoBtn ? (
        <SignupInfoBtn id={id} onClick={onClick} style={style} from={from}>
          <span>{children}</span> <span className="fs-18 weight-600">&#10230;</span>
        </SignupInfoBtn>
      ) : ctaBoxBtn ? (
        <CtaBoxBtn id={id} onClick={onClick} style={style}>
          <span>{children}</span> <span className="fs-18 weight-600">&#10230;</span>
        </CtaBoxBtn>
      ) : regionalsLinkBtn ? (
        <RegionalsBannerBtn id={id} style={style} href={href}>
          <span>{children}</span>
        </RegionalsBannerBtn>
      ) : formBtn ? (
        <FormBtn id={id} onClick={onClick} style={style} active={active} disabled={disabled} darkTheme={darkTheme}>
          {children}
        </FormBtn>
      ) : secondaryBtn ? (
        <SecondaryBtn id={id} onClick={onClick} style={style} active={active} disabled={disabled} loadingText={loadingText} ref={ref} darkTheme={darkTheme}>
          {active ? (
            <Fragment>
              <span className="pr-2">{loadingText ? loadingText : children}</span>
              <div className="spinner-border spinner-border-sm thin-spinner-border text-success" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </Fragment>
          ) : (
            <span>{children}</span>
          )}
        </SecondaryBtn>
      ) : ghostBtn ? (
        <GhostBtn id={id} onClick={onClick} style={style} active={active} disabled={disabled} loadingText={loadingText} ref={ref} darkTheme={darkTheme}>
          {active ? (
            <Fragment>
              <span className="pr-2">{loadingText ? loadingText : children}</span>
              <div className="spinner-border spinner-border-sm thin-spinner-border text-success" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </Fragment>
          ) : (
            <span>{children}</span>
          )}
        </GhostBtn>
      ) : pricingBarBtn ? (
        <PricingBarBtn isIndividualPricing={isIndividualPricing} id={id} onClick={onClick} style={style} disabled={disabled}>
          {children}
        </PricingBarBtn>
      ) : roundedBtn ? (
        <RoundedBtn id={id} onClick={onClick} style={style} disabled={disabled}>
          {children}
        </RoundedBtn>
      ) : spinnerBtn ? (
        <SpinnerBtn id={id} onClick={onClick} style={style} active={active} disabled={disabled} loadingText={loadingText} ref={ref} darkTheme={darkTheme}>
          {active ? (
            <Fragment>
              <span className="pr-2">{loadingText ? loadingText : children}</span>
              <div className="spinner-border spinner-border-sm thin-spinner-border text-light" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </Fragment>
          ) : (
            <span>{children}</span>
          )}
        </SpinnerBtn>
      ) : darkBtn ? (
        <DarkSiteBtn id={id} onClick={onClick} style={style} active={active} disabled={disabled} loadingText={loadingText} ref={ref} darkTheme={darkTheme}>
          {active ? (
            <Fragment>
              <span className="pr-2">{loadingText ? loadingText : children}</span>
              <div className="spinner-border spinner-border-sm thin-spinner-border text-success" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </Fragment>
          ) : (
            <span>{children}</span>
          )}
        </DarkSiteBtn>
      ) : (
        <SiteBtn id={id} onClick={onClick} style={style} disabled={disabled} darkTheme={darkTheme}>
          {children}
        </SiteBtn>
      )}
    </Fragment>
  );
}
